var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTherapistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 71,
    viewBox: "0 0 67 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 71,
    rx: 33.5,
    fill: "#DBF9E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 37V29H21C20.2044 29 19.4413 29.3161 18.8787 29.8787C18.3161 30.4413 18 31.2044 18 32V50C18.0015 50.1857 18.0547 50.3674 18.1536 50.5245C18.2525 50.6817 18.3932 50.8083 18.56 50.89C18.7207 50.9631 18.8978 50.9923 19.0735 50.9747C19.2491 50.9572 19.417 50.8934 19.56 50.79L24.71 47H38.15C38.529 47.0112 38.9063 46.9445 39.2585 46.8039C39.6106 46.6634 39.9302 46.4521 40.1974 46.183C40.4646 45.914 40.6736 45.5929 40.8117 45.2398C40.9498 44.8867 41.0139 44.5089 41 44.13V43H30C28.4087 43 26.8826 42.3679 25.7574 41.2426C24.6321 40.1174 24 38.5913 24 37Z",
    fill: "#7EC38E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 22H30C29.2044 22 28.4413 22.3161 27.8787 22.8787C27.3161 23.4413 27 24.2044 27 25V37C27 37.7956 27.3161 38.5587 27.8787 39.1213C28.4413 39.6839 29.2044 40 30 40H43.55L48.33 43.71C48.4721 43.8151 48.6395 43.8806 48.8152 43.8999C48.9908 43.9192 49.1685 43.8917 49.33 43.82C49.5002 43.739 49.644 43.6115 49.7448 43.4522C49.8457 43.293 49.8995 43.1085 49.9 42.92V25C49.9004 24.2214 49.5981 23.4731 49.057 22.9133C48.5158 22.3534 47.7782 22.026 47 22Z",
    fill: "#34623F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapistIcon);
export default __webpack_public_path__ + "static/media/therapist-icon.316e3cdc16d09839919533ae78493eed.svg";
export { ForwardRef as ReactComponent };